/* Faris Collection — interactive extras: wishlist, recently viewed, image lightbox,
   outfit finder, card tilt and add-to-cart feedback. Everything degrades gracefully. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const T = window.theme || { strings: {} };
  const money = (c) => (window.formatMoney ? window.formatMoney(c) : `Rs. ${Math.round(c / 100)}`);
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // storage that never throws (private mode, blocked storage)
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* ignore */ } },
  };
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toast.t);
    toast.t = setTimeout(() => el.classList.remove('is-visible'), 2400);
  }

  /* ---------------- wishlist ---------------- */
  const WISH = 'fc-wishlist';
  function renderWishlist() {
    const items = store.get(WISH);
    const handles = new Set(items.map((i) => i.handle));
    $$('[data-wish-handle]').forEach((b) => {
      const on = handles.has(b.dataset.wishHandle);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
    $$('[data-wish-count]').forEach((c) => { c.textContent = items.length || ''; c.dataset.count = items.length; });
    const list = $('[data-wish-list]');
    const empty = $('[data-wish-empty]');
    if (!list) return;
    empty.hidden = items.length > 0;
    list.innerHTML = items.map((i) => `
      <div class="wish-item">
        <a href="${esc(i.url)}" class="media">${i.img ? `<img src="${esc(i.img)}" alt="" loading="lazy">` : ''}</a>
        <div><span class="card__type">${esc(i.type)}</span><a href="${esc(i.url)}" class="wish-item__title">${esc(i.title)}</a><span class="small">${esc(i.price)}</span></div>
        <button type="button" class="cart-item__remove" data-wish-remove="${esc(i.handle)}">${esc(T.strings.remove || 'Remove')}</button>
      </div>`).join('');
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (b) {
      e.preventDefault();
      const item = JSON.parse(b.dataset.wish);
      let items = store.get(WISH);
      const exists = items.some((i) => i.handle === item.handle);
      items = exists ? items.filter((i) => i.handle !== item.handle) : [item, ...items].slice(0, 40);
      store.set(WISH, items);
      renderWishlist();
      toast(exists ? T.strings.wishRemoved : T.strings.wishAdded);
      return;
    }
    const r = e.target.closest('[data-wish-remove]');
    if (r) { store.set(WISH, store.get(WISH).filter((i) => i.handle !== r.dataset.wishRemove)); renderWishlist(); }
  });
  renderWishlist();

  /* ---------------- recently viewed ---------------- */
  const RECENT = 'fc-recent';
  const current = $('[data-recent-product]');
  let currentHandle = null;
  if (current) {
    try {
      const p = JSON.parse(current.textContent);
      currentHandle = p.handle;
      store.set(RECENT, [p, ...store.get(RECENT).filter((i) => i.handle !== p.handle)].slice(0, 12));
    } catch (e) { /* ignore */ }
  }
  function renderRecent() {
    $$('[data-recently-viewed]').forEach((sec) => {
      const items = store.get(RECENT).filter((i) => i.handle !== currentHandle).slice(0, Number(sec.dataset.limit || 8));
      sec.hidden = items.length === 0;
      $('[data-recent-list]', sec).innerHTML = items.map((i) => `
        <a href="${esc(i.url)}" class="recent-item">
          <div class="media">${i.img ? `<img src="${esc(i.img)}" alt="" loading="lazy">` : ''}</div>
          <div class="recent-item__title">${esc(i.title)}</div><div class="small">${esc(i.price)}</div>
        </a>`).join('');
    });
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-recent-clear]')) { store.set(RECENT, []); renderRecent(); }
  });
  renderRecent();

  /* ---------------- lightbox (product gallery) ---------------- */
  const lb = $('[data-lightbox]');
  if (lb) {
    const img = $('[data-lightbox-img]', lb);
    const stage = $('[data-lightbox-stage]', lb);
    const count = $('[data-lightbox-count]', lb);
    let srcs = [];
    let idx = 0;
    let lastFocus = null;
    const show = (i) => {
      idx = (i + srcs.length) % srcs.length;
      lb.classList.remove('is-zoomed');
      img.src = srcs[idx];
      count.textContent = srcs.length > 1 ? `· ${idx + 1} / ${srcs.length}` : '';
      $$('[data-lightbox-prev],[data-lightbox-next]', lb).forEach((b) => (b.hidden = srcs.length < 2));
    };
    const open = (slide) => {
      const gallery = slide.closest('[data-gallery]');
      srcs = $$('[data-zoom]', gallery).map((s) => s.dataset.zoom);
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.body.classList.add('is-locked');
      show(Number(slide.dataset.zoomIndex || 0));
      $('[data-lightbox-close]', lb).focus();
    };
    const close = () => { lb.hidden = true; document.body.classList.remove('is-locked'); lastFocus && lastFocus.focus(); };
    document.addEventListener('click', (e) => {
      const slide = e.target.closest('[data-zoom]');
      if (slide && !e.target.closest('a,button')) open(slide);
    });
    document.addEventListener('keydown', (e) => {
      const slide = e.target.closest && e.target.closest('[data-zoom]');
      if (slide && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(slide); return; }
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    });
    $('[data-lightbox-close]', lb).addEventListener('click', close);
    $('[data-lightbox-prev]', lb).addEventListener('click', () => show(idx - 1));
    $('[data-lightbox-next]', lb).addEventListener('click', () => show(idx + 1));
    // click to zoom at the pointer, move to pan
    stage.addEventListener('click', (e) => {
      if (e.target !== img) { close(); return; }
      const r = img.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      lb.classList.toggle('is-zoomed');
    });
    stage.addEventListener('mousemove', (e) => {
      if (!lb.classList.contains('is-zoomed')) return;
      const r = stage.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    });
    // swipe
    let sx = null;
    stage.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (sx === null || lb.classList.contains('is-zoomed')) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
      sx = null;
    });
  }

  /* ---------------- outfit finder ---------------- */
  $$('[data-finder]').forEach((root) => {
    let data = [];
    try { data = JSON.parse($('[data-finder-data]', root).textContent); } catch (e) { return; }
    const state = { occasion: '', occasionHandle: '', style: '', age: '' };
    const first = $('[data-finder-group="occasion"] .is-active', root);
    if (first) { state.occasion = first.dataset.value; state.occasionHandle = first.dataset.handle; }
    const list = $('[data-finder-list]', root);
    const countEl = $('[data-finder-count]', root);
    const allLink = $('[data-finder-all]', root);
    const empty = $('[data-finder-empty]', root);
    const handleize = (s) => s.toLowerCase().replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

    function match(p) {
      if (state.occasion && !p.tags.includes(state.occasion)) return false;
      if (state.age && !p.sizes.includes(state.age)) return false;
      if (state.style) {
        if (state.style.includes('+')) {
          if (!['Kurta Pajama', 'Shalwar Kameez'].includes(p.type) || !p.tags.includes(state.style)) return false;
        } else if (p.type !== state.style) return false;
      }
      return true;
    }
    function pairFor(p) {
      if (!state.style.includes('+')) return null;
      const layer = state.style.endsWith('Prince Coat') ? 'Prince Coat' : 'Waistcoat';
      return p.pairs.find((x) => x.type === layer) || null;
    }
    function render() {
      const results = data.filter(match);
      countEl.textContent = results.length;
      empty.hidden = results.length > 0;
      list.innerHTML = results.slice(0, 6).map((p, i) => {
        const pair = pairFor(p);
        const total = pair ? p.price + pair.price : p.price;
        const href = pair ? `${p.u}?look=${pair.h}#complete-the-look` : p.u;
        return `<a href="${esc(href)}" class="finder-item" style="animation-delay:${i * 60}ms">
          <div class="composition${pair ? '' : ' composition--lifestyle'}">
            <span class="composition__main">${p.img ? `<img src="${esc(p.img)}" alt="" loading="lazy">` : ''}</span>
            ${pair ? `<span class="composition__pair">${pair.img ? `<img src="${esc(pair.img)}" alt="" loading="lazy">` : ''}</span><span class="composition__plus">+</span>` : ''}
          </div>
          <div class="finder-item__title">${esc(p.t)}${pair ? ` <span class="muted">+</span> ${esc(pair.t)}` : ''}</div>
          <div class="finder-item__meta">${pair ? '<span>Look</span>' : ''}${money(total)}</div>
        </a>`;
      }).join('');
      // "see all" goes to the native collection, filtered by look tag and size
      let url = `/collections/${state.occasionHandle || 'all'}`;
      if (state.style) url += `/${handleize(state.style)}`;
      if (state.age) url += `?${encodeURIComponent(root.dataset.sizeParam || 'filter.v.option.size')}=${encodeURIComponent(state.age)}`;
      allLink.href = url;
      allLink.hidden = results.length === 0;
    }
    root.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-finder-group] .chip');
      if (!chip) return;
      const group = chip.closest('[data-finder-group]');
      $$('.chip', group).forEach((c) => { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip); });
      const key = group.dataset.finderGroup;
      state[key] = chip.dataset.value;
      if (key === 'occasion') state.occasionHandle = chip.dataset.handle;
      render();
    });
    render();
  });

  /* ---------------- tilt on occasion & look cards (desktop pointer only) ---------------- */
  if (!reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('.occasion-card, .look-card').forEach((card) => {
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(900px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateY(-4px)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }

  /* ---------------- add-to-cart feedback ---------------- */
  document.addEventListener('cart:added', (e) => {
    const src = e.detail && e.detail.source;
    const cartIcon = $('[data-open-drawer="CartDrawer"]');
    if (src && src.matches('.btn')) {
      const label = src.textContent;
      src.classList.add('is-added');
      src.textContent = `✓ ${T.strings.addedShort || 'Added'}`;
      setTimeout(() => { src.classList.remove('is-added'); src.textContent = label; }, 1800);
    }
    if (cartIcon) {
      cartIcon.classList.remove('cart-bump');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('cart-bump');
    }
    // fly the product image into the bag
    // no image animation on the product page (main form, sticky bar, complete-the-look)
    if (!src || src.closest('[data-product], [data-sticky-atc], [data-look]')) return;
    const scope = src.closest('.card');
    const from = scope && $('img', scope);
    if (!from || !cartIcon || reduceMotion) return;
    const a = from.getBoundingClientRect();
    const b = cartIcon.getBoundingClientRect();
    if (!a.width) return;
    const fly = document.createElement('img');
    fly.src = from.currentSrc || from.src;
    fly.className = 'fly-img';
    Object.assign(fly.style, { left: `${a.left}px`, top: `${a.top}px`, width: `${a.width}px`, height: `${a.height}px` });
    document.body.appendChild(fly);
    requestAnimationFrame(() => {
      const dx = b.left + b.width / 2 - (a.left + a.width / 2);
      const dy = b.top + b.height / 2 - (a.top + a.height / 2);
      fly.style.transform = `translate(${dx}px, ${dy}px) scale(${Math.max(0.06, 24 / a.width)})`;
      fly.style.opacity = '0.2';
    });
    setTimeout(() => fly.remove(), 800);
  });
})();
